import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAppliedjobs } from "../../Api/appliedJobs";

export const fetchAppliedJobs = createAsyncThunk(
    "appliedjob/fetch",
    async (_, { rejectWithValue }) => {
      try {
        const response = await getAppliedjobs();
        return response;
      } catch (error) {
        return rejectWithValue(error.response.data);
      }
    },
  );
  